export const initialArticles = [
  {
    id: "2f3gv36yf23345f2",
    video: "https://youtu.be/B-ytMSuwbf8",
    shareImg: "/images/feed-img3.jpg",
    description:
      "Today, I was working out of the Lagos Ministry of Justice. Trust me this happenned like few minutes ago - At or about 8.50am.",
    comments: 0,
    shares: 2,
    reactions: 92,
    likes: ["Abiola Ayoola Ayodele", "samuel darlinton", "Wizzy doe", "Fanny"],
    actor: {
      image: "/images/john-doe.png",
      email: "nkachukwuvictor2016@gmail.com",
      name: "Nkachukwu Victor",
      // date: 1663449252,
    },
  },
  {
    id: "4fsdf2r9sf23rfafa",
    video: "",
    shareImg: "/images/feed-img2.jpg",
    description:
      "Today, I was working out of the Lagos Ministry of Justice. Trust me this happenned like few minutes ago - At or about 8.50am.",
    comments: 1,
    shares: 4,
    reactions: 92,
    likes: ["Woke Emmanuel", "Bisola Sandra"],
    actor: {
      image: "/images/john-doe.png",
      email: "nkachukwuvictor2020@gmail.com",
      name: "Nkachukwu Cyril",
      // date: 1663449252,
    },
  },
];